<template>
  <div>
    <section-header heading="2" ja="クーポンのもらい方・使い方" />
    <div class="infoLink">
      <div class="link-text" @click="onAppli">既にアプリ版のプリクラONをご利用中の方はコチラ</div>
      <div class="link-text" @click="onHome">既にWeb版のプリクラONをご利用中の方はコチラ</div>
    </div>
    <div class="couponGet" v-show="couponData.length > 0">
      <div v-for="(value, index) in couponData" :key="index">
        <div class="coupon-content" v-if="index === current">
          <div class="coupon-img">
            <img :src="getImg(value.imgPath)"/>
          </div>
          <div class="buttonArea">
            <sub-btn v-if="current >= 1" @click="onPrev">前へ</sub-btn>
            <normal-btn @click="onNext">{{ couponData.length-1 === index ? '無料会員登録へ': '次へ' }}</normal-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import NormalBtn from '../components/NormalBtn';
import SubBtn from '../components/SubBtn';
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "Tutorial",
  components: {SectionHeader, NormalBtn, SubBtn},
  mixins: [Protobuf],
  data () {
    return {
      current: 0,
      couponData: []
    }
  },
  watch: {
    '$route.params.type'() {
      this.current = 0
    }
  },
  mounted(){
    const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
    const message = pb.KumaMasterSettingReq.create({
      id: this.id
    })
    const encoded = pb.KumaMasterSettingReq.encode(message).finish()

    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS) {
          this.couponData = decoded.masterTutorialList.slice(15, 18)
        } else {
          this.$_error('Error', { title: 'クーポンのもらい方・使い方', statusCode: 100 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'クーポンのもらい方・使い方', statusCode: 100 })
      })
  },
  methods: {
    onAppli() {
      window.open("https://app.adjust.com/j71pddb", "_blank")
    },
    onHome() {
      this.$router.push('/')
    },
    onNext() {
      if (this.current === this.couponData.length-1){
        this.$router.push("/accountRegistration1")
        return
      }
      this.current++
      window.scrollTo(0,0)
    },
    onPrev() {
      this.current = this.current -1
      window.scrollTo(0,0)
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
  }
}
</script>

<style lang="scss" scoped>
  .coupon-img {
    padding-top: 30px;
    img { max-width: 100%; }
  }
  .buttonArea {
    display: flex;
    .SubBtn { margin: 20px 0 0 30px; }
  }
  .infoLink {
  margin-top: 20px;
  padding: 0 30px;
  cursor: pointer;
  & > div {
    margin-top: 15px;
    padding-right: 30px;
    text-align: right;
    font-size: 10px;
    color: #F63C5B;
    background-image:
      linear-gradient(to left, #F63C5B, #F63C5B),
      linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
    background-repeat: no-repeat;
    background-size: 24px 1px, 8px 8px;
    background-position: right 70%, right 40%;
    }
  }
</style>
